// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import Backdrop from "@mui/material/Backdrop";

import { forwardRef, useImperativeHandle, useState } from "react";
import { CloseButton, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap"
import * as webjobService from '../Services/webjobServices';
import React from "react";
import {  Badge, Card ,Table} from "react-bootstrap";

const StoreList = ({ stores }) => {
  return (
    <Card className="shadow-sm border-0">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Stores</h5>
          <Badge bg="secondary">{stores?.length || 0} Stores</Badge>
        </div>

        <div className="table-responsive">
          <Table hover bordered className="align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Store Name</th>
                <th>Order Count</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {stores?.length > 0 ? (
                stores.map((store, index) => (
                  <tr key={index}>
                    <td className="fw-semibold">
                      {store.storeName}
                    </td>

                    <td>
                      <Badge bg="info">
                        {store.orderCount}
                      </Badge>
                    </td>

                    <td>
                      <Badge bg={store.isActive ? "success" : "secondary"}>
                        {store.isActive ? "Active" : "Inactive"}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted py-4">
                    No stores found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};
export const StoreDetailsModal = forwardRef(({},ref,) => {
        const [show,setShow]=useState(false);
        const [data,setData]=useState([]);
        useImperativeHandle(ref, () => {
                return {
                    // ... your methods ...
                    toggle(e) {
                        getData(e);
                        setShow(true);
                    }
                };
        }, []);
        const toggle=()=>{
            setShow(false);
            setData([]);
        };
        const getData=(e)=>{
            const body={
                "email": e.emailId,
                "dropshipperId": Number(e.companyId),
                "storeId": e.storeIds
                // "storeId": 
            };
            webjobService.getordercountbystoreid(body).then((res)=>{
                // console.log(res.data)
                setData(res.data?.data);
            }).catch((err)=>{

            });
        }
     return(
        <Modal 
            show={show}
            onHide={toggle}
            size="md"
            backdrop={'static'}
        >
            <ModalHeader  >
                    <ModalTitle id="LiveDemoExampleLabel">Store Details</ModalTitle>
                    <CloseButton onClick={toggle} style={{color:'#fff'}}/>
                
            </ModalHeader>
            <ModalBody className="p-0">
                {
                    data?.length ?   <StoreList stores={data}/> : <div className="text-center text-muted py-4">No stores found</div>
                }
                 
            </ModalBody>
            
        </Modal>
    )
  })